<template>
	<div class="container">
		<div class="content">
			<h2 class="mb_15">{{ $t('cs.title') }}</h2>
			<div class="card">
				<h3 class="title mb_15">{{ $t('cs.notice') }}</h3>
				<div class="cs_notice">
					<accordion v-for="item in noticeList" :key="item.seq" class="notice">
						<accordion-item>
							<template v-slot:accordion-trigger>
								<p>{{ item.title }}</p>
								<div>
									<span class="date">{{
										$dayjs(item.regdate).format('YYYY.MM.DD')
									}}</span>
									<span class="accordion_trigger_icon"></span>
								</div>
							</template>
							<template v-slot:accordion-content>
								<div class="notice-accordion-content">
									<div v-html="item.content"></div>
								</div>
							</template>
						</accordion-item>
					</accordion>
					<pagination
						:totalCount="pageNavigation.total_count"
						:totalPage="pageNavigation.total_page"
						:curPage="pageNavigation.cur_page"
						:point="pageNavigation.point"
						:firstPage="pageNavigation.first_page"
						:lastPage="pageNavigation.last_page"
						@change="pageChangeHandler"
					></pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
import pagination from '@/components/Pagination';
import { fetchFaqList, fetchFaqTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'Notice.m',
	components: {
		Accordion,
		AccordionItem,
		pagination,
	},
	data() {
		return {
			faqTypeList: [],
			noticeList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
		};
	},
	computed: {
		faqNotice() {
			return this.faqTypeList.find(item => {
				return item.name.toLowerCase() === 'notice';
			});
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			Promise.all([this.loadFaqTypeList()]).then(() => {
				this.loadNoticeList();
			});
		},
		async loadFaqTypeList() {
			const { data } = await fetchFaqTypes().catch(commonError);
			this.faqTypeList = data;
		},
		async loadNoticeList() {
			const params = {
				type_seq: this.faqNotice.seq,
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.noticeList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadNoticeList();
		},
	},
};
</script>
